import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { LabelL } from '@sorare/core/src/atoms/typography';
import { ExtraMessageWithBlurredBg } from '@sorare/core/src/components/onboarding/ExtraMessageWithBlurredBg';
import { HighlightOverlay } from '@sorare/core/src/components/onboarding/HighlightOverlay';
import { useIsTabletAndAbove } from '@sorare/core/src/hooks/device/useIsTabletAndAbove';
import useLifecycle, { LIFECYCLE } from '@sorare/core/src/hooks/useLifecycle';
import { useOnboardingHighlights } from '@sorare/core/src/hooks/useOnboardingHighlights';

export const CommonMarketOnboarding = () => {
  const [step, setStep] = useState(0);
  const isTabletAndAbove = useIsTabletAndAbove();
  const { lifecycle, update: updateLifecycle } = useLifecycle();
  const onboardingHighlights = useOnboardingHighlights();

  if (lifecycle?.sawCommonMarketOnboarding || !onboardingHighlights)
    return null;

  if (step === 0) {
    return (
      <HighlightOverlay
        key="BuyCommonCard"
        highlightNames={['BuyCommonCard']}
        onClose={() => setStep(1)}
        extras={[
          {
            nextTo: 'BuyCommonCard',
            render: props => (
              <ExtraMessageWithBlurredBg
                align="center"
                anchor="top"
                positionProps={props}
                fullWidth={!isTabletAndAbove}
              >
                <LabelL>
                  <FormattedMessage
                    id="CommonMarketOnboarding.BuyCommonCard.cost"
                    defaultMessage="Points are your currency to swap Common Cards. They are based on a player's average score"
                  />
                </LabelL>
              </ExtraMessageWithBlurredBg>
            ),
          },
        ]}
      />
    );
  }

  return (
    <HighlightOverlay
      key="CommonMarketHeader"
      highlightNames={['CommonMarketHeader']}
      onClose={() => {
        updateLifecycle(LIFECYCLE.sawCommonMarketOnboarding, true);
      }}
      extras={[
        {
          nextTo: 'CommonMarketHeader',
          render: props => (
            <ExtraMessageWithBlurredBg
              align="center"
              anchor="bottom"
              positionProps={props}
              fullWidth={!isTabletAndAbove}
            >
              <LabelL>
                <FormattedMessage
                  id="CommonMarketOnboarding.CommonMarketHeader.add"
                  defaultMessage="Add: use points to get new cards"
                />
              </LabelL>
              <LabelL>
                <FormattedMessage
                  id="CommonMarketOnboarding.CommonMarketHeader.drop"
                  defaultMessage="Drop: gain points by selling cards"
                />
              </LabelL>
            </ExtraMessageWithBlurredBg>
          ),
        },
      ]}
    />
  );
};
